/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'
import { updateOffice } from '../../slice/OfficeSlice'


const basePath = '/offices'

const OfficesEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
({
  fetchOffices: builder.query<any, any>({
    query: () => `${basePath}`,
    providesTags: ['offices']
  }),

  createOffice: builder.mutation<any, any>({
    query: (body) => ({
      url: `${basePath}`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['offices']
  }),

  deleteOffice: builder.mutation<any, any>({
    query: (id) => ({
      url: `${basePath}?id=${id}`,
      method: 'delete',
    }),
    invalidatesTags: ['offices'],
  }),

  updateOffice: builder.mutation<any, any>({
    query: ({ id, body }) => ({
      url: `${basePath}/${id}`,
      method: 'put',
      body,
    }),
    // async onQueryStarted(arg, { dispatch, queryFulfilled }) {
    //   const { data } = await queryFulfilled;
    //   // Optimistically update the office in the store
    //   dispatch(updateOffice(data));
    // },
    invalidatesTags: ['offices'],
  }),

  deleteOfficeImage: builder.mutation<any, any>({
    query: (id) => ({
      url: `/office-images?imageId=${id}`,
      method: 'delete',
    }),
    invalidatesTags: ['offices'],
  }),

  addOfficeImage: builder.mutation<any, any>({
    query: (body) => ({
      url: `/office-images/upload`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['offices'],
  }),

  deleteThisImage: builder.mutation<any, any>({
    query: (id) => ({
      url: `/office-images?imageId=${id}`,
      method: 'delete',
    }),
    invalidatesTags: ['offices'],
  }),

  addOfficeSpecification: builder.mutation<any, any>({
    query: ({ body, id }) => ({
      url: `/office/specifications?officeId=${id}`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['offices'],
  }),

  deleteOfficeSpecifications: builder.mutation<any, any>({
    query: (id) => ({
      url: `/office/specifications?officeId=${id}`,
      method: 'delete',
    }),
    invalidatesTags: ['offices']
  })

})

export default OfficesEndpoints
